import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { Helmet } from "react-helmet-async";
import SEO from "@/components/SEO";

const DatenLoeschen = () => {
  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>Konto- und Datenlöschung – MusiKonzept</title>
        <meta name="description" content="Antrag auf Löschung personenbezogener Daten gemäß Art. 17 DSGVO. Erfahre, wie du dein MusiKonzept-Konto und deine Daten löschen lassen kannst." />
      </Helmet>
      <SEO title={`Datenlöschung gemäß DSGVO | MusiKonzept`} description={`Antrag auf Löschung deiner personenbezogenen Daten gemäß Art. 17 DSGVO bei MusiKonzept.`} path="/daten-loeschen" />
      <Header />
      <main className="pt-32 pb-20">
        <div className="container mx-auto px-6">
          <div className="max-w-3xl mx-auto">
            <h1 className="text-3xl md:text-4xl font-bold mb-10">
              Antrag auf Löschung personenbezogener Daten
            </h1>

            <div className="space-y-8 text-foreground/90 leading-relaxed">
              <section>
                <h2 className="text-xl font-semibold mb-3">Dein Recht auf Löschung</h2>
                <p>
                  Gemäß Art. 17 der Datenschutz-Grundverordnung (DSGVO) hast du das Recht, die Löschung deines Nutzerkontos sowie aller damit verbundenen personenbezogenen Daten zu beantragen. Wir kommen diesem Recht nach, sofern keine gesetzlichen Aufbewahrungspflichten entgegenstehen.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold mb-3">So stellst du einen Löschantrag</h2>
                <p>
                  Sende eine E-Mail an:{" "}
                  <a href="mailto:info@musikonzept.de" className="text-primary underline font-medium">
                    info@musikonzept.de
                  </a>
                </p>
                <p className="mt-2">
                  Bitte gib in deiner E-Mail die Adresse an, mit der dein Konto bei MusiKonzept registriert wurde, damit wir deine Anfrage eindeutig zuordnen können.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold mb-3">Bearbeitungszeit</h2>
                <p>
                  Dein Löschantrag wird innerhalb von <strong>30 Tagen</strong> nach Eingang bearbeitet. Du erhältst eine Bestätigung per E-Mail, sobald die Löschung abgeschlossen ist.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold mb-3">Umfang der Löschung</h2>
                <p>Folgende Daten werden im Rahmen der Kontolöschung entfernt:</p>
                <ul className="list-disc pl-6 space-y-1 mt-2">
                  <li>Benutzerprofil (Name, E-Mail-Adresse, Profilbild)</li>
                  <li>Kursfortschritte und Lernstände</li>
                  <li>Community-Beiträge und Kommentare</li>
                  <li>Gespeicherte Notizen und Favoriten</li>
                  <li>Zertifikate und Prüfungsdaten</li>
                  <li>Chat-Verläufe</li>
                </ul>
              </section>

              <section>
                <h2 className="text-xl font-semibold mb-3">Gesetzliche Aufbewahrungspflichten</h2>
                <p>
                  Bestimmte Daten, die steuer- oder handelsrechtlichen Aufbewahrungspflichten unterliegen (z.&nbsp;B. Rechnungen und Zahlungsbelege), können gemäß den geltenden gesetzlichen Vorgaben auch nach der Kontolöschung weiterhin gespeichert bleiben. Diese Daten werden ausschließlich zu den gesetzlich vorgeschriebenen Zwecken aufbewahrt und nach Ablauf der Aufbewahrungsfrist gelöscht.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold mb-3">Kontakt</h2>
                <p>
                  Bei Fragen zum Datenschutz oder zur Löschung deiner Daten wende dich an:{" "}
                  <a href="mailto:info@musikonzept.de" className="text-primary underline font-medium">
                    info@musikonzept.de
                  </a>
                </p>
              </section>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default DatenLoeschen;
